import { faComments } from "@fortawesome/pro-solid-svg-icons";
import React from "react";

import { ContactSellerActionsStep1 } from "@/mk2/apps/bazaar/containers/ProductDetail/ContactSellerActionsStep1";
import { slugToParams } from "@/mk2/apps/bazaar/helpers";
import { ProductEntity, ProductQuality } from "@/mk2/apps/bazaar/schemas";
import { bazaarProductDetailUrl } from "@/mk2/apps/bazaar/urls";
import { signupUrl } from "@/mk2/apps/users/urls";
import { Btn, BtnSidePadding, BtnType } from "@/mk2/components/Btn";
import { url } from "@/mk2/helpers/urls";
import { BZ2_JUST_SEND_MESSAGE, BZ2_SEND_MESSAGE_ANONYMOUS } from "@/mk/autogenerated/translation";
import { bazaar_redirect_to_eshop_url } from "@/mk/urls/functions";

interface OwnProps {
    product: ProductEntity;
    canSendMsg: boolean;
    sellerPhone: string;
    eshopUrl: string;
}

export const ContactSellerForAnonymous: React.FunctionComponent<OwnProps> = ({
    product,
    canSendMsg,
    sellerPhone,
    eshopUrl,
}) => {
    const sendMsgBtnLabel = [ProductQuality.SERVICES, ProductQuality.JOBS].includes(product.quality)
        ? BZ2_JUST_SEND_MESSAGE
        : BZ2_SEND_MESSAGE_ANONYMOUS;
    const sendMsgBtnUrl = url(
        signupUrl,
        {},
        {
            mkutm_medium: "product",
            mkutm_campaign: "buyer_registration_required",
            mkutm_source: "modrykonik",
            mkutm_content: product.id,
            next: url(bazaarProductDetailUrl, slugToParams(product.slug), {
                openContactForm: 1,
            }),
        },
    );
    const sendMsgBtn = canSendMsg ? (
        <Btn type={BtnType.Blue} label={sendMsgBtnLabel} link={sendMsgBtnUrl} icon={faComments} />
    ) : null;

    const phoneLink = sellerPhone ? (
        <Btn
            type={BtnType.Link}
            label={sellerPhone}
            link={`tel:${sellerPhone}`}
            linkTarget="_blank"
            linkRel="noopener"
            sidePadding={BtnSidePadding.None}
            asAnchor
        />
    ) : null;

    const eshopLink = eshopUrl ? (
        <Btn
            type={BtnType.Link}
            label={eshopUrl.replace(/^https?:\/\//, "").split("/")[0]}
            link={bazaar_redirect_to_eshop_url(product.id)}
            linkTarget="_blank"
            linkRel="noopener"
            sidePadding={BtnSidePadding.None}
            asAnchor
        />
    ) : null;

    return (
        <ContactSellerActionsStep1
            sendMsgBtn={sendMsgBtn}
            phoneLink={phoneLink}
            eshopLink={eshopLink}
        />
    );
};
